export type { CountryIsoCode } from './countryPhoneData';
export { countriesData, countriesIsoCodes, isValidCountry } from './countryPhoneData';
